/**
 * @author Supraja Ramesh
 */
import constants, { ACCESS_TOKEN, HTTP_METHODS } from "../../../settings/shared/constants";
import axiosClient from "../../common";

function _constructHeader() {
    const jwtToken = localStorage.getItem(ACCESS_TOKEN);

    return {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${jwtToken}`
    };
}

function getProjectVersion(projectId) {
    return axiosClient({
        url: constants.api.projectVersions.getProjectVersion + "/" + projectId,
        method: HTTP_METHODS.GET,
        headers: _constructHeader()
    });
}

function restoreCheckpoint(checkpointId) {
    return axiosClient({
        url: constants.api.projectVersions.restore + "/" + checkpointId,
        method: HTTP_METHODS.GET,
        headers: _constructHeader()
    });
}

const ProjectVersionService = {
    getProjectVersion,
    restoreCheckpoint
};

export default ProjectVersionService;
